import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useReducer,
} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  onFetchRepo,
  onFetchRepoSuccess,
  onFetchRepoFailure,
} from '../actions/Repo';
import repoReducer, { IState } from '../reducers/Repo';
import { fetchRepositoriesDetails } from '../services/github';

interface IContextProps {
  state: IState;
  dispatch: ({ type }: { type: string }) => void;
}

export const RepoContext = createContext({} as IContextProps);

/** Initial State */
const initialState: IState = {
  repoDetails: {},
  loading: false,
};

function RepoProvider(props: any) {
  const [state, dispatch] = useReducer(repoReducer, initialState);
  const { repo }: { repo: string } = useParams();
  const history = useHistory();

  const value = { state, dispatch };

  const initialLoad = useCallback(async () => {
    try {
      dispatch(onFetchRepo());
      const repoDetails = await fetchRepositoriesDetails(repo);
      dispatch(onFetchRepoSuccess(repoDetails));
    } catch (error) {
      dispatch(onFetchRepoFailure());
      alert('An unexpected error ocurred, try again. API Rate Limit Exceeded?');
      history.push('/');
      console.error(error);
    }
  }, [repo, history]);

  useEffect(() => {
    initialLoad();
  }, [initialLoad]);

  return <RepoContext.Provider value={value} {...props} />;
}

function useRepoContext() {
  return useContext(RepoContext);
}

export { RepoProvider, useRepoContext };
